import { Injectable } from '@angular/core';
import { TopLevelLayers } from '../menu/view-menu/top-level-layers';
import { ObstacleCSVContent, ObstacleCsvModel, ObstacleLayer } from '../models/Obstacle';
import { MapService } from './map.service';
import { ModalConfirmationService } from './modal-confirmation.service';
import { PointsService } from './points.service';
import { ProjectService } from './project.service';
import { UtilsService } from './utils.service';
import olMap from 'ol/Map';
import { Feature } from 'ol';
import Point from 'ol/geom/Point';
import * as olProj from 'ol/proj';
import { ConfigurationConstants } from '../models/EnumTypes';


@Injectable({
  providedIn: 'root'
})
export class ObstacleDataService {



  constructor(private pointsService: PointsService,
    private mapService: MapService,
    private modalConfirmationService : ModalConfirmationService,
    private utilsService : UtilsService,
    public projectService: ProjectService,
    ) {
    }

  createObstaclesFromModel(model : ObstacleCsvModel){
    var validLines : boolean[] = this.validateContent(model);

    const newLayer = new TopLevelLayers(true, model.layerName, ObstacleLayer.getNewLayers(), this.mapService.getMap('map'),this.modalConfirmationService,
                      null, null, null, null,model.fileName);

    let activateLayer: boolean = false;
    for (let i = 0; i < validLines.length; i++){
      if (validLines[i]){
        activateLayer = true;
        this.addObstacleToLayer(model.fileContent[i], newLayer);
      }
    }
    if (activateLayer){
      this.pointsService.staticLayer.childLayers.push(newLayer);
      this.saveState(model, this.projectService.activeProject.id)
    }
    if(!model.visible){
      this.pointsService.staticLayer.onSelect(newLayer);
    }
  }
  activateObstacleDataLayer(topLevelLayer: TopLevelLayers){
    this.pointsService.staticLayer.onSelect(topLevelLayer);
    //this.globalSelectionService.staticLayers.onSelect(topLevelLayer);
    let obstacleData : Map<string, ObstacleCsvModel> = this.getObstacleDataFromLocalStorage();
    if(obstacleData == null){
      return;
    }
    let storedObstacleDataModel : ObstacleCsvModel = obstacleData.get(topLevelLayer.name);
    storedObstacleDataModel.visible = !storedObstacleDataModel.visible
    obstacleData.set(storedObstacleDataModel.layerName, storedObstacleDataModel);
    localStorage.setItem("obstacleData_" + this.projectService.activeProject.id, JSON.stringify(obstacleData, this.utilsService.replacer));

  }
  getObstacleDataFromLocalStorage(){
    const obstacleDataString = localStorage.getItem("obstacleData_"+ this.projectService.activeProject.id);
    let obstacleData : Map<string, ObstacleCsvModel>;
    if(obstacleDataString == null || obstacleDataString == "{}"){
      obstacleData = new Map<string, ObstacleCsvModel>();
    }
    else{
      obstacleData = JSON.parse(obstacleDataString, this.utilsService.reviver);
    }
    return obstacleData;
  }
  saveState(model : ObstacleCsvModel, projectID: number) : void{
    const obstacleDataString = localStorage.getItem("obstacleData_"+ projectID);
    let obstacleData : Map<string, ObstacleCsvModel>;
    if(obstacleDataString == null || obstacleDataString == "{}"){
      obstacleData = new Map<string, ObstacleCsvModel>();
    }
    else{
      obstacleData = JSON.parse(obstacleDataString, this.utilsService.reviver);
    }
    obstacleData.set(model.layerName, model);
    localStorage.setItem("obstacleData_" + projectID, JSON.stringify(obstacleData, this.utilsService.replacer));
  }

  loadState(projectid : number) : void{
    this.pointsService.staticLayer.childLayers = [this.pointsService.staticLayer.childLayers[0]];
    const obstacleDataString = localStorage.getItem("obstacleData_"+ projectid);
    if(obstacleDataString == null || obstacleDataString == "{}"){
      return;
    }
    let obstacleData : Map<string, ObstacleCsvModel> = JSON.parse(obstacleDataString, this.utilsService.reviver);
    obstacleData.forEach(el => {
      this.createObstaclesFromModel(el);
    });
  }

  deleteObstacle(name : string, projectID: number) : void {
    var obstacleDataString = localStorage.getItem("obstacleData_" + projectID);
    var obstacleData : Map<string, ObstacleCsvModel>;
    if(obstacleDataString == null || obstacleDataString == "{}"){
      obstacleData = new Map<string, ObstacleCsvModel>();
    }
    else{
      obstacleData = JSON.parse(obstacleDataString, this.utilsService.reviver);
    }
    obstacleData.delete(name);
    localStorage.setItem("obstacleData_" + projectID, JSON.stringify(obstacleData, this.utilsService.replacer));
  }

  createObstacleFeatureFromCSVLine(csvLineObstacle: ObstacleCSVContent): Feature {
    const feat = new Feature({
      geometry: new Point(olProj.fromLonLat([Number(csvLineObstacle.longitude), Number(csvLineObstacle.latitude)], this.mapService.getMaps().getView().getProjection())),
      elevation: csvLineObstacle.elevation,
      notes: csvLineObstacle.textNote,
    })
    return feat;

  }

  addObstacleToLayer(csvLineObstacle: ObstacleCSVContent, topLevelLayer: TopLevelLayers): void{
    let humanSource = topLevelLayer.layers
      .find((element) => element.id === 'obstacleHuman')
      .olLayer.getSource();
    let naturalSource = topLevelLayer.layers
      .find((element) => element.id === 'obstacleNatural')
      .olLayer.getSource();
    let unknownSource = topLevelLayer.layers
      .find((element) => element.id === 'obstacleUnknown')
      .olLayer.getSource();

    let marker = this.createObstacleFeatureFromCSVLine(csvLineObstacle);
    switch (csvLineObstacle.type) {
      case '0':
        humanSource.addFeature(marker);
        break;
      case '1':
        naturalSource.addFeature(marker);
        break;
      default:
        unknownSource.addFeature(marker);
        break;
    }
  }

  validateContent(model: ObstacleCsvModel): boolean[]{
    let valids : boolean[] = [];
    model.fileContent.forEach((line) => {
      if (model.decimalSeparator != '.'){
        const replace = model.decimalSeparator;
        const re = new RegExp(replace,"g");
        line.latitude = line.latitude.replace(re, '.');
        line.longitude = line.longitude.replace(re, '.');
        line.elevation = line.elevation.replace(re, '.');
      }
      if(!this.isValidLat(line.latitude) || !this.isValidLon(line.longitude) || !this.isValidAltitude(line.elevation) || !this.isValidType(line.type) ){
        valids.push(false);
      } else {
        valids.push(true);
      }
    });
    return valids;
  }

  private isValidLat(lat : string) : boolean {
		let latDouble : number = Number.parseFloat(lat);
			if (!Number.isNaN(latDouble) && latDouble <= ConfigurationConstants.LATITUDE_MAX && latDouble >= ConfigurationConstants.LATITUDE_MIN) {
				return true;
			} else {
				return false;
			}
	}

	private isValidLon(lon : string) : boolean {
		let lonDouble : number = Number.parseFloat(lon);
			if (!Number.isNaN(lonDouble) && lonDouble <= ConfigurationConstants.LONGITUDE_MAX && lonDouble >= ConfigurationConstants.LONGITUDE_MIN) {
				return true;
			} else {
				return false;
			}
	}

  private isValidAltitude(altitude : string) : boolean {
		return !Number.isNaN(Number.parseFloat(altitude));
	}

  private isValidType(type : string) : boolean {
		return !Number.isNaN(Number.parseInt(type));
	}
}
